export default "__VITE_ASSET__BY7otavi__"